import * as React from "react";
import { Layout } from "antd";

import Map from "./components/Map/Map";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
import FooterComponent from "../../components/FooterComponent";
import { EventFilter } from "../../api/Types";
import { Analytics } from "./components/Analytics";
import { AnalyticsFilter } from "../../components/AnalyticsFilter";
import { Layouts } from "../../constants/Enums";
import DefectRegister from "../../store/defectRegister";
import DefectValidator from "../../components/DefectValidator";

import OrganisationProfile from "../OrganisationProfile";
import SideBarComponent from "../../components/SideBarComponent";
import { StoreAnalytics } from "../../store/storeAnalytics";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";
import Paths from "../../constants/PathsBreadcrumbs";
import { authStore } from "../../store/authStore";

const { Content } = Layout;
const store = new StoreAnalytics();
const SitPanel: React.FC = () => {
  useBreadcrumbs(Paths.spMap);

  const initialFilter: EventFilter = {
    buildings: null,
    dateFrom: null,
    dateTo: null,
    deadlinesViolated: null,
    diameter: null,
    disconnections: null,
    eliminated: null,
    eventLevel: "Current",
    gridTypeIds: [],
  };
  const [modal, setModal] = React.useState(false);
  const [filter, setFilter] = React.useState(initialFilter);
  const [ticks, setTicks] = React.useState(1);
  const { userProfile } = authStore;
  const initialLayout = DefectRegister.hasToken()
    ? Layouts.Default
    : Layouts.Login;
  const [layout, setLayout] = React.useState(initialLayout);
  const refPosition = React.useRef<[number, number[]]>([
    9.9,
    [3339250.2539037718, 8368154.581258831],
  ]);

  const onFilterChange = (e) => {
    setFilter(e);
    setTicks(ticks + 1);
  };

  const onOpenAnalytics = () => {
    setLayout(Layouts.Analytics);
  };

  const onCloseAnalytics = () => {
    setLayout(Layouts.Default);
  };

  const onLogout = () => {
    setLayout(Layouts.Login);
  };

  const openValidator = () => {
    setLayout(Layouts.Dispatcher);
  };

  switch (layout) {
    case Layouts.Default:
      return (
        <Layout
          className="container"
          style={{ flexDirection: "row", height: "95vh" }}
        >
          <SideBarComponent
            filter={initialFilter}
            store={store}
            onFilterChange={onFilterChange}
            onOpenAnalytics={onOpenAnalytics}
            onLogout={onLogout}
          />
          <Layout className="site-layout" key={ticks}>
            <HeaderComponent filter={filter} />
            {/* {modal && <OrganisationProfile />} */}
            <Content className="site-layout-background">
              <Layout className="layout-wrapper">
                <Map refPosition={refPosition} />
                <div className="left-top">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5px"
                    height="5px"
                    viewBox="0 0 5 5"
                  >
                    <g>
                      <path
                        fill="none"
                        stroke="#DAE5EB"
                        strokeMiterlimit="10"
                        d="M0.026,20.167V4.022c0-2.2,1.8-4,4-4h12.891"
                      />
                    </g>
                    <g opacity="0.6">
                      <path
                        fill="#FFFFFF"
                        d="M12.917-35.51c0-2.2-1.8-4-4-4h-48.641c-2.2,0-4,1.8-4,4v45.521c0,2.2,1.8,4,4,4h35.75c2.2,0,4-1.8,4-4V3.976c0-2.2,1.8-4,4-4h4.891c2.2,0,4-1.8,4-4V-35.51z"
                      />
                    </g>
                  </svg>
                </div>
                <div className="right-top">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5px"
                    height="5px"
                    viewBox="0 0 5 5"
                  >
                    <g>
                      <path
                        fill="none"
                        stroke="#DAE5EB"
                        strokeMiterlimit="10"
                        d="M0.026,20.167V4.022c0-2.2,1.8-4,4-4h12.891"
                      />
                    </g>
                    <g opacity="0.6">
                      <path
                        fill="#FFFFFF"
                        d="M12.917-35.51c0-2.2-1.8-4-4-4h-48.641c-2.2,0-4,1.8-4,4v45.521c0,2.2,1.8,4,4,4h35.75c2.2,0,4-1.8,4-4V3.976c0-2.2,1.8-4,4-4h4.891c2.2,0,4-1.8,4-4V-35.51z"
                      />
                    </g>
                  </svg>
                </div>
                <div className="left-bottom">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5px"
                    height="5px"
                    viewBox="0 0 5 5"
                  >
                    <g>
                      <path
                        fill="none"
                        stroke="#DAE5EB"
                        strokeMiterlimit="10"
                        d="M0.026,20.167V4.022c0-2.2,1.8-4,4-4h12.891"
                      />
                    </g>
                    <g opacity="0.6">
                      <path
                        fill="#FFFFFF"
                        d="M12.917-35.51c0-2.2-1.8-4-4-4h-48.641c-2.2,0-4,1.8-4,4v45.521c0,2.2,1.8,4,4,4h35.75c2.2,0,4-1.8,4-4V3.976c0-2.2,1.8-4,4-4h4.891c2.2,0,4-1.8,4-4V-35.51z"
                      />
                    </g>
                  </svg>
                </div>
                <div className="right-bottom">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5px"
                    height="5px"
                    viewBox="0 0 5 5"
                  >
                    <g>
                      <path
                        fill="none"
                        stroke="#DAE5EB"
                        strokeMiterlimit="10"
                        d="M0.026,20.167V4.022c0-2.2,1.8-4,4-4h12.891"
                      />
                    </g>
                    <g opacity="0.6">
                      <path
                        fill="#FFFFFF"
                        d="M12.917-35.51c0-2.2-1.8-4-4-4h-48.641c-2.2,0-4,1.8-4,4v45.521c0,2.2,1.8,4,4,4h35.75c2.2,0,4-1.8,4-4V3.976c0-2.2,1.8-4,4-4h4.891c2.2,0,4-1.8,4-4V-35.51z"
                      />
                    </g>
                  </svg>
                </div>
              </Layout>
            </Content>
            <FooterComponent filter={filter} onOpenValidator={openValidator} />
          </Layout>
        </Layout>
      );
    case Layouts.Analytics:
      return (
        <Layout className="container" style={{ flexDirection: "row" }}>
          <div className={"analytics-filter-custom"}>
            <AnalyticsFilter
              store={store}
              onFilterChange={onFilterChange}
              onCloseAnalytics={onCloseAnalytics}
            />
          </div>
          <Layout className="site-layout">
            <HeaderComponent filter={filter} />
            <div className="analytics-map-custom"></div>
            <Analytics store={store} />
          </Layout>
        </Layout>
      );
    // case Layouts.Login:
    //   return <Login onSuccess={onLoginSuccess} />;
    default:
      return (
        <Layout
          className="container"
          style={{ flexDirection: "column", height: "100vh" }}
        >
          <Layout className="site-layout">
            <DefectValidator
              onFinish={() => {
                setLayout(Layouts.Default);
              }}
            />
          </Layout>
        </Layout>
      );
  }
};

export default SitPanel;
